import { h, FunctionComponent } from 'preact';
import { CheckboxGroupProps } from '../types/forms';
import CheckboxInput from './CheckboxInput';

const CheckboxGroup: FunctionComponent<CheckboxGroupProps> = props => {
  const { id, isValid, errorMessage = '' } = props;

  return (
    <div id={id} className='checkbox'>
      {isValid === false && <span class='sr-only'>{errorMessage}</span>}
      <CheckboxInput {...props} />
    </div>
  );
};

export default CheckboxGroup;
